import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
    const navigate = useNavigate();

    const handleClose = () => {
        navigate(-1); // Navigate back to the previous page
    };

    return (
      <PrivacyContainer>
        <Helmet>
          <title>Privacy Policy | SolarAIDD</title>
          <meta name="description" content="Read the SolarAIDD Privacy Policy to understand how we handle EL image data and user information on our AI defect detection platform." />
          <meta name="keywords" content="SolarAIDD privacy, data security, EL image storage, AI data ethics, CSIR data policy, photovoltaic data protection, industrial AI security"/>
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href="https://solaraidd.csir.co.za/privacy-policy" />
          
          {/* Structured Data for Legal/Policy clarity */}
          <script type="application/ld+json">
            {`
              {
                "@context": "https://schema.org",
                "@type": "WebPage",
                "name": "Privacy Policy",
                "description": "Information regarding the collection and protection of data on the SolarAIDD platform.",
                "publisher": {
                  "@type": "Organization",
                  "name": "CSIR"
                }
              }
            `}
          </script>
        </Helmet>

        <SectionTitle>1. Introduction</SectionTitle>
        <Paragraph>
          This Privacy Policy outlines how we collect, use, and protect your information when you use our services. We are committed to safeguarding your privacy and ensuring the protection of your personal data.
        </Paragraph>
  
        <SectionTitle>2. Information We Collect</SectionTitle>
        <Paragraph>
          We collect personal information such as your name, email address, and other details when you register on our platform. We also collect information about your usage of our services.
        </Paragraph>
  
        <SectionTitle>3. How We Use Your Information</SectionTitle>
        <Paragraph>
          The information we collect is used to provide, maintain, and improve our services. We may also use it to communicate with you, such as sending you updates, responding to inquiries, or providing support.
        </Paragraph>
  
        <SectionTitle>4. Data Security</SectionTitle>
        <Paragraph>
          We implement a variety of security measures to maintain the safety of your personal information. However, no method of transmission over the internet is 100% secure, so we cannot guarantee absolute security.
        </Paragraph>
  
        <SectionTitle>5. Third-Party Services</SectionTitle>
        <Paragraph>
          We may use third-party services to help us operate our business and provide the services. These third-party providers have their own privacy policies addressing how they handle your information.
        </Paragraph>
  
        <SectionTitle>6. Cookies</SectionTitle>
        <Paragraph>
          We use cookies to enhance your experience. You can choose to disable cookies through your browser settings, but this may affect your ability to use certain features of our platform.
        </Paragraph>
  
        <SectionTitle>7. Changes to This Privacy Policy</SectionTitle>
        <Paragraph>
          We may update this Privacy Policy from time to time. Any changes will be posted on this page, and we encourage you to review this page periodically.
        </Paragraph>
  
        <SectionTitle>8. Your Consent</SectionTitle>
        <Paragraph>
          By using our website, you hereby consent to our Privacy Policy and agree to its terms.
        </Paragraph>
  
        <SectionTitle>9. Contact Us</SectionTitle>
        <Paragraph>
          If you have any questions regarding this Privacy Policy, please contact us at  solaraiddsupport@csir.co.za.
        </Paragraph>
        
      </PrivacyContainer>
    );
  };
  
  export default PrivacyPolicy;

  const PrivacyContainer = styled.div`
  padding: 40px;
  max-width: 800px;
  margin: 0 auto;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  margin-top: 20px;
  color: #333;
`;

const Paragraph = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  color: #666;
  margin-bottom: 20px;
`;